<div class="component-content">
    <div id="task-details">
        <div id="task-details-header-container">
            <div id="header">
                <div id="details-header">
                    <mat-icon class="icon-64" svgIcon="tasks"></mat-icon>
                    <h1>{{componentTitle}}</h1>
                    <h2>{{componentSubTitle}}</h2>
                </div>
                <div id="buttons">
                    <button class="lc-stroked-button" mat-stroked-button (click)="goToCustomer()" *ngIf="hasCanSeeCustomersRight">
                        <mat-icon svgIcon="go-to"></mat-icon>Customer
                    </button>
                    <button class="lc-stroked-button" mat-stroked-button (click)="deleteTask()" *ngIf="hasCanDeleteTasksRight">
                        <mat-icon svgIcon="delete"></mat-icon>Delete
                    </button>
                </div>
            </div>
            <div id="basic-info">
                <div class="row-multiple">
                    <div class="long-item">
                        <span>Created on</span>
                        <p [hidden]="!selectedTask.createdOn">{{selectedTask.createdOn | date:'mediumDate'}} |
                            {{selectedTask.createdOn | date:'shortTime'}}</p>
                    </div>
                    <div class="long-item">
                        <span>Finalized on</span>
                        <p [hidden]="!selectedTask.finalizedStamp">{{selectedTask.finalizedStamp | date:'mediumDate'}} |
                            {{selectedTask.finalizedStamp | date:'shortTime'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="lc-tab-group" id="tab-group" (selectedTabChange)="tabChanged($event)">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="icon-32 lc-label-icon" svgIcon="input"></mat-icon>
                    <span class="tab-label">Input</span>
                </ng-template>
                <div class="buttons">
                    <button class="download-button lc-stroked-button" mat-stroked-button (click)="saveInput()">
                        <mat-icon svgIcon="download"></mat-icon>Download
                    </button>
                    <button class="resend-order-button lc-stroked-button" mat-stroked-button
                        *ngIf="resendButtonVisible()"
                        (click)="scheduleTaskForReRun()">
                        <mat-icon svgIcon="recycle"></mat-icon>Resend
                    </button>
                </div>
                <app-task-file-contents [taskContent]="taskInputContent"></app-task-file-contents>
            </mat-tab>
            
            <div *ngIf="selectedTask.processFlow === processFlow.result || selectedTask.processFlow === processFlow.invoice">
            <mat-tab label="Map">
                <ng-template mat-tab-label>
                    <mat-icon class="icon-32 lc-label-icon" svgIcon="swap-horiz"></mat-icon>
                    <span class="tab-label">Map</span>
                </ng-template>
                <div class="buttons">
                    <button class="download-button lc-stroked-button" mat-stroked-button (click)="saveMap()">
                        <mat-icon svgIcon="download"></mat-icon>Download
                    </button>
                </div>
                <app-task-file-contents [taskContent]="taskMapContent"></app-task-file-contents>
                </mat-tab>
                <mat-tab label="Transform">
                    <ng-template mat-tab-label>
                        <mat-icon color="primary" class="lc-label-icon">bolt</mat-icon>
                        <span class="tab-label">Transform</span>
                    </ng-template>
                    <div class="buttons">
                        <button class="download-button lc-stroked-button" mat-stroked-button (click)="saveTransform()">
                            <mat-icon svgIcon="download"></mat-icon>Download
                        </button>
                    </div>
                    <app-task-file-contents [taskContent]="taskTransformContent"></app-task-file-contents>
                </mat-tab>
           
            </div>

            <div *ngIf="selectedTask.processFlow === processFlow.order">
                <mat-tab label="Transform">
                    <ng-template mat-tab-label>
                        <mat-icon color="primary" class="lc-label-icon">bolt</mat-icon>
                        <span class="tab-label">Transform</span>
                    </ng-template>
                    <div class="buttons">
                        <button class="download-button lc-stroked-button" mat-stroked-button (click)="saveTransform()">
                            <mat-icon svgIcon="download"></mat-icon>Download
                        </button>
                    </div>
                    <app-task-file-contents [taskContent]="taskTransformContent"></app-task-file-contents>
                </mat-tab>
                <mat-tab label="Map">
                    <ng-template mat-tab-label>
                        <mat-icon class="icon-32 lc-label-icon" svgIcon="swap-horiz"></mat-icon>
                        <span class="tab-label">Map</span>
                    </ng-template>
                    <div class="buttons">
                        <button class="download-button lc-stroked-button" mat-stroked-button (click)="saveMap()">
                            <mat-icon svgIcon="download"></mat-icon>Download
                        </button>
                    </div>
                    <app-task-file-contents [taskContent]="taskMapContent"></app-task-file-contents>
                </mat-tab>
            </div>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="icon-32 lc-label-icon" svgIcon="output"></mat-icon>
                    <span class="tab-label">Output</span>
                </ng-template>
                <div class="buttons">
                    <button class="download-button lc-stroked-button" mat-stroked-button (click)="saveOutput()">
                        <mat-icon svgIcon="download"></mat-icon>Download
                    </button>
                </div>
                <app-task-file-contents [taskContent]="taskOutputContent"></app-task-file-contents>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="icon-32 lc-label-icon" svgIcon="audit-trail"></mat-icon>
                    <span class="tab-label">Audit trail</span>
                </ng-template>
                <app-task-audit-trail [taskAuditTrail]="taskAuditTrail"></app-task-audit-trail>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
